import { VaccineDto } from 'src/dto/vaccine.dto'
import { VaccineService } from 'src/services/api/vaccine.service'

export class VaccineController {
  private service: VaccineService

  constructor() {
    this.service = new VaccineService()
  }

  public async getVaccineList(): Promise<VaccineDto[]> {
    const response = await this.service.getVaccineList()
    return response.data
  }
}
